import React, { useEffect, useState } from "react";
import { useTheme } from "../contexts/ThemeContext";

/**
 * Splash — full-screen 2.4-s splash that fires once per session whenever a
 * non-default iCaard theme is active (Ghana public holiday, festival, user's
 * birthday). The default theme suppresses the splash so we don't slow down
 * the app every reload.
 *
 * Session-scoped (`sessionStorage`) so users don't see the same splash on
 * every tab switch within a single session.
 */
export default function Splash() {
  const theme = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Suppress on default theme — no celebration today.
    if (!theme || theme.id === "default") return;
    const key = `icaard_splash_seen_${theme.id}_${new Date().toDateString()}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2600);
    return () => clearTimeout(t);
  }, [theme.id]);

  if (!visible) return null;
  return (
    <div
      data-testid="theme-splash"
      className="fixed inset-0 z-[99999] flex flex-col items-center justify-center text-white"
      style={{
        background: `radial-gradient(circle at 50% 40%, ${theme.palette}aa 0%, #09090F 70%)`,
        animation: "kiosk-splash-fade 2.6s ease-in-out forwards",
      }}
    >
      <div className="text-7xl sm:text-8xl mb-4 select-none" aria-hidden>{theme.splash_emoji}</div>
      <div className="text-[10px] tracking-[0.4em] uppercase font-bold text-white/70 mb-2">i Caard</div>
      <h1 className="font-display font-black text-3xl sm:text-5xl text-center px-6 max-w-2xl">{theme.greeting || theme.name}</h1>
    </div>
  );
}
